import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button } from '@themesberg/react-bootstrap';
import API from "../../utils/api";
import { ToastAlert } from "../ToastAlert";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import PdfUpload from "./pdfUpload";
export const UploadClaimForm = () => {
  const [hasProfile, setHasProfile] = useState(false);
  const [profile, setProfile] = useState(null);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const checkUserProfile = async () => {
      try {
        const response = await API.get("/profile/me");
        if (response?.data) {
          setHasProfile(true);
          setProfile(response.data);
        } else {
          setHasProfile(false);
        }
      } catch (error) {
        setHasProfile(false);
      }
    };

    checkUserProfile();
  }, []);

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    companyName: "",
    street: "",
    postalCity: "",
    description: "",
    customDescription: "",
    pdfFile: [],
    pdfFile1: null
  });


  useEffect(() => {
    if (profile) {
      const [streetPart, postalCityPart] = (profile.address || "").split(","); // split if comma separated
      if (profile.userType === "company") {
        setFormData((prev) => ({
          ...prev,
          name: profile.fullName || "",
          companyName: profile.companyName || "",
          street: streetPart?.trim() || "",
          postalCity: postalCityPart?.trim() || "",
          email: profile.email || ""
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          name: profile.fullName || "",
          street: streetPart?.trim() || "",
          postalCity: postalCityPart?.trim() || "",
          email: profile.email || ""
        }));
      }
    }
  }, [profile]);


  const [alert, setAlert] = useState({
    show: false,
    message: "",
    variant: "info",
  });

  const handleChange = (field) => (e) => {
    if (field === "pdfFile" || field === "pdfFile1") {
      setFormData({ ...formData, [field]: e.target.files[0] });
    } else {
      setFormData({ ...formData, [field]: e.target.value });
    }
  };
  // For Dropzone files
  const handleFileChange = (field) => (files) => {
    setFormData((prev) => ({
      ...prev,
      [field]: files,
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // start loader
    const finalDescription =
      formData.description === "custom"
        ? formData.customDescription
        : formData.description;

    if (!formData.name || !formData.email || formData.pdfFile.length === 0) {
      showAlert(t("uploadClaimFormTranslations.alertFillAll"), "danger");
      setLoading(false);
      return;
    }

    const data = new FormData();
    data.append("name", formData.name);
    data.append("email", formData.email);
    data.append("description", finalDescription);
    formData.pdfFile.forEach((file) => {
      data.append("pdfFile", file);
    });
    if (formData.pdfFile1) {
      data.append("pdfFile1", formData.pdfFile1);
    }
    if (profile?.userType === "company") {
      data.append("companyName", formData.companyName);
    }
    data.append("address", `${formData.street}, ${formData.postalCity}`);


    try {
      const response = await API.post("/claims/initial", data, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (!response || response.error) {
        throw new Error(t("uploadClaimFormTranslations.alertUploadError"));
      }
      showAlert(t("uploadClaimFormTranslations.alertSubmitSuccess"), "success");
      setFormData({
        name: profile.fullName || "",
        email: profile.email || "",
        companyName: profile.companyName || "",
        street: (profile.address || "").split(",")[0]?.trim() || "",
        postalCity: (profile.address || "").split(",")[1]?.trim() || "",
        description: "",
        customDescription: "",
        pdfFile: [],
        pdfFile1: null
      });


    } catch (error) {
      showAlert(error.message || t("uploadClaimFormTranslations.alertSubmitError"), "danger");
    }
    finally {
      setLoading(false); // stop loader
    }
  };

  const showAlert = (message, variant = "info") => {
    setAlert({ show: true, message, variant });
  };

  return (
    <>
      <ToastAlert
        show={alert.show}
        onClose={() => setAlert({ ...alert, show: false })}
        message={alert.message}
        variant={alert.variant}
      />
      {hasProfile ? (
        <Card border="light" className="bg-white shadow-sm mb-4">
          <Card.Body>
            <h5 className="mb-4">{t("uploadClaimFormTranslations.submitClaimTitle")}</h5>
            <Form onSubmit={handleSubmit}>

              {/* Row 1: Name and Email */}
              <Row style={{ display: "none" }}>
                <Col md={6} className="mb-3">
                  <Form.Group controlId="name">
                    <Form.Label>{t("uploadClaimFormTranslations.nameLabel")}</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder={t("uploadClaimFormTranslations.namePlaceholder")}
                      value={formData.name}
                      onChange={handleChange("name")}
                      readOnly
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Group controlId="email">
                    <Form.Label>{t("uploadClaimFormTranslations.emailLabel")}</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder={t("uploadClaimFormTranslations.emailPlaceholder")}
                      value={formData.email}
                      onChange={handleChange("email")}
                      readOnly
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              {profile?.userType === "company" && (
                <Col style={{ display: "none" }} md={6} className="mb-3">
                  <Form.Group controlId="companyName">
                    <Form.Label>{t("uploadClaimFormTranslations.companyNameLabel")}</Form.Label>
                    <Form.Control
                      type="text"
                      value={formData.companyName}
                      readOnly
                      required
                    />
                  </Form.Group>
                </Col>
              )}

              {/* <Col md={6} className="mb-3">
                <Form.Group controlId="address">
                  <Form.Label>{t("uploadClaimFormTranslations.addressLabel")}</Form.Label>
                  <Form.Control
                    type="text"
                    value={formData.address}
                    readOnly
                    required
                  />
                </Form.Group>
              </Col> */}
              <Row style={{ display: "none" }}>
                <Col md={6} className="mb-3">
                  <Form.Group controlId="street">
                    <Form.Label>{t("uploadClaimFormTranslations.addressLabel")} Street</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter street"
                      value={formData.street}
                      onChange={handleChange("street")}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col md={6} className="mb-3">
                  <Form.Group controlId="postalCity">
                    <Form.Label>{t("uploadClaimFormTranslations.addressLabel")} Postalcode + City</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter postal code + city"
                      value={formData.postalCity}
                      onChange={handleChange("postalCity")}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>


              {/* Row 2: Description */}
              <Row>
                <Col md={12} className="mb-3">
                  <Form.Group controlId="description">
                    <Form.Label>{t("uploadClaimFormTranslations.contractTypeLabel")}</Form.Label>
                    <Select
                      classNamePrefix="react-select"
                      options={[
                        { value: "", label: t("uploadClaimFormTranslations.contractTypePlaceholder") },
                        { value: "work contract", label: t("uploadClaimFormTranslations.contractTypeWork") },
                        { value: "work delivery contract", label: t("uploadClaimFormTranslations.contractTypeWorkDelivery") },
                        { value: "service contract", label: t("uploadClaimFormTranslations.contractTypeService") },
                        { value: "goods delivery contract", label: t("uploadClaimFormTranslations.contractTypeGoodsDelivery") },
                        { value: "purchase contract", label: t("uploadClaimFormTranslations.contractTypePurchase") },
                        { value: "custom", label: t("uploadClaimFormTranslations.contractTypeCustom") },
                      ]}
                      value={
                        [
                          { value: "", label: t("uploadClaimFormTranslations.contractTypePlaceholder") },
                          { value: "work contract", label: t("uploadClaimFormTranslations.contractTypeWork") },
                          { value: "work delivery contract", label: t("uploadClaimFormTranslations.contractTypeWorkDelivery") },
                          { value: "service contract", label: t("uploadClaimFormTranslations.contractTypeService") },
                          { value: "goods delivery contract", label: t("uploadClaimFormTranslations.contractTypeGoodsDelivery") },
                          { value: "purchase contract", label: t("uploadClaimFormTranslations.contractTypePurchase") },
                          { value: "custom", label: t("uploadClaimFormTranslations.contractTypeCustom") },
                        ].find((opt) => opt.value === formData.description) || null
                      }
                      onChange={(selected) =>
                        setFormData({ ...formData, description: selected ? selected.value : "" })
                      }
                      placeholder={t("uploadClaimFormTranslations.contractTypePlaceholder")}
                      isClearable
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          minHeight: "32px",
                          width: "205px",
                          fontSize: "14px",
                          width: "100%",
                          borderRadius: "8px",
                          boxShadow: state.isFocused ? "0 0 0 1px #4f46e5" : base.boxShadow,
                          borderColor: state.isFocused ? "#4f46e5" : base.borderColor,
                          "&:hover": { borderColor: "#4f46e5" },
                        }),
                        option: (base, state) => ({
                          ...base,
                          fontSize: "14px",
                          padding: "6px 12px",
                          backgroundColor: state.isSelected
                            ? "#4f46e5"
                            : state.isFocused
                              ? "#e0e7ff"
                              : "white",
                          color: state.isSelected ? "white" : "black",
                        }),
                        singleValue: (base) => ({
                          ...base,
                          fontSize: "14px",
                          color: "#111827",
                        }),
                        placeholder: (base) => ({
                          ...base,
                          fontSize: "14px",
                          color: "#6b7280",
                        }),
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />

                  </Form.Group>
                </Col>
              </Row>

              {formData.description === "custom" && (
                <Row>
                  <Col md={12} className="mb-3">
                    <Form.Group controlId="customDescription">
                      <Form.Label>{t("uploadClaimFormTranslations.customContractTypeLabel")}</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder={t("uploadClaimFormTranslations.customContractTypePlaceholder")}
                        value={formData.customDescription}
                        onChange={handleChange("customDescription")}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
              )}

              {/* Row 4: Upload PDF */}
              <Row>
                <Col md={6}>
                  <PdfUpload
                    label={t("uploadClaimFormTranslations.uploadPdfLabel")}
                    onFileChange={handleFileChange("pdfFile")}
                    file={formData.pdfFile}
                  />


                </Col>
                <Col md={6}>
                  <PdfUpload
                    label={t("uploadClaimFormTranslations.uploadAdditionalPdfLabel")}
                    onFileChange={handleFileChange("pdfFile1")}
                    file={formData.pdfFile1}
                  />
                </Col>
              </Row>




              <Button type="submit" className="mt-3" variant="primary" disabled={loading}>
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Uploading...
                  </>
                ) : (
                  t("uploadClaimFormTranslations.saveButton")
                )}
              </Button>

            </Form>
          </Card.Body>
        </Card>
      ) : (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
          <Button onClick={() => navigate("/client/your-profile")}>
            {t("uploadClaimFormTranslations.createProfileFirst")}
          </Button>
        </div>
      )}
    </>
  );
};
